// extracted by mini-css-extract-plugin
module.exports = {"block":"FormMonth_block_3KHPQ","label":"FormMonth_label_2TcuO","required":"FormMonth_required_19KBa","error":"FormMonth_error_I3Yl6"};